import { useState } from 'react';
import DangerIcon from '../../../assets/icons/danger.svg?react';
import { useDeleteOpmContractNumberInfo } from '../../../hooks/queries/resourceRelationQueries';

const OpmContractDeleteModal = ({ onClose, drResource, contractNumber, onSuccess }) => {
  const { mutate: deleteContract, isPending } = useDeleteOpmContractNumberInfo();
  const [errorMessage, setErrorMessage] = useState('');

  const handleDelete = () => {
    if (!drResource?.DrResourceSysId || !contractNumber) return;
    setErrorMessage('');

    deleteContract(
      {
        drResourceSysId: drResource.DrResourceSysId,
        contractNumber,
      },
      {
        onSuccess: () => {
          onSuccess?.();
          onClose();
        },
        onError: (error) => {
          console.error('OPM 고객계약번호 삭제 실패:', error);
          setErrorMessage(
            error?.response?.data?.message ||
              error?.message ||
              'OPM 고객계약번호 삭제에 실패했습니다.'
          );
        },
      }
    );
  };

  return (
    <div className="modal-background">
      <div className="modal-container">
        <div className="modal-header flex-col gap-10">
          <DangerIcon className="text-error" />
          <h3>해당 고객계약번호를 삭제하시겠습니까?</h3>
          <p className="text-b2-400 text-gray-600 text-center">
            해당 번호에 해당되는 충전 인프라는{' '}
            <span className="text-b2-700 text-primary">
              {drResource?.ResourceName || '-'}
            </span>
            과의 연결이 해제됩니다.
          </p>
        </div>
        <div className="modal-content">
          <table className="gray-table">
            <tbody>
              <tr>
                <th>계약번호</th>
                <td>{contractNumber}</td>
              </tr>
              <tr>
                <th>DR 자원</th>
                <td>{drResource?.ResourceName || '-'}</td>
              </tr>
            </tbody>
          </table>
          {errorMessage && (
            <p className="text-b3-400 text-red-500 mt-5">{errorMessage}</p>
          )}
        </div>
        <div className="modal-footer">
          <button
            className="btn py-5 px-10 btn-style-5"
            onClick={onClose}
            disabled={isPending}
          >
            취소
          </button>
          <button
            className="btn py-5 px-10 btn-primary"
            onClick={handleDelete}
            disabled={isPending}
          >
            {isPending ? '삭제 중...' : '삭제하기'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OpmContractDeleteModal;
